import { supabase } from "@/lib/supabase";

export type SectionType = "manual" | "category" | "hero" | "continue_watching";

export interface HomeSection {
  id: string;
  sort_order: number;
  visible: boolean;
  type: SectionType;
  title: string;
  subtitle: string | null;
  payload: {
    content_ids?: string[];
    category?: string;
    limit?: number;
    content_id?: string;
  };
  created_at: string;
  updated_at: string;
}

export type HomeSectionInput = Omit<HomeSection, "id" | "created_at" | "updated_at">;

export async function getHomeSections(): Promise<HomeSection[]> {
  const { data, error } = await supabase
    .from("home_sections")
    .select("*")
    .order("sort_order", { ascending: true });

  if (error) throw error;
  return data as HomeSection[];
}

export async function createHomeSection(input: HomeSectionInput): Promise<HomeSection> {
  const { data, error } = await supabase
    .from("home_sections")
    .insert(input)
    .select()
    .single();

  if (error) throw error;
  return data as HomeSection;
}

export async function updateHomeSection(id: string, input: Partial<HomeSectionInput>): Promise<void> {
  const { error } = await supabase
    .from("home_sections")
    .update(input)
    .eq("id", id);

  if (error) throw error;
}

export async function deleteHomeSection(id: string): Promise<void> {
  const { error } = await supabase
    .from("home_sections")
    .delete()
    .eq("id", id);

  if (error) throw error;
}

export async function reorderHomeSections(ordered: { id: string; sort_order: number }[]): Promise<void> {
  const updates = ordered.map(({ id, sort_order }) =>
    supabase.from("home_sections").update({ sort_order }).eq("id", id)
  );
  await Promise.all(updates);
}
